export { default } from "/home/runner/work/core-frontend/core-frontend/app/routes/contact.tsx";